// FeaturesSection.jsx
// Desktop: 3-col cards (light, orange, dark teal)
// Mobile: stacked single column
// import Kids from "../Assests/feature-learning-image.jpg"
// import headerimg from "../Assests/feature-traning-image.jpg"
// import techer from "../Assests/teacertraing.png"
// import Cartoon from "../Assests/feature-traning-item-image.png"


import Kids from "../Assests/feature-learning-image.jpg"
import headerimg from "../Assests/feature-traning-image.jpg"
import techer from "../Assests/FeaturesSection/SDS_0631.JPG"
import Cartoon from "../Assests/feature-traning-item-image.png"


const IMG_KIDS_CARTOON = Kids;
// const IMG_TEACHER_CLASS = techer;
const AVATAR1 = "https://static.vecteezy.com/system/resources/thumbnails/049/174/246/small/a-smiling-young-indian-man-with-formal-shirts-outdoors-photo.jpg";
const AVATAR2 = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQJp0qhEgcOaRscS93404KdEg-j5Oqk8o36LQ&s";
const AVATAR3 = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTFSaLz693rDjzK_V-nGa-tI7a9nMkKqyUt7g&s";

const PillTag = ({ label }) => (
  <span className="inline-flex items-center gap-1 border border-gray-300 rounded-full px-3 py-1 text-xs font-semibold text-gray-600 bg-white">
    <span className="text-[#FF6B35] text-sm font-black">✦</span>
    {label}
  </span>
);

const TeacherIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" className="w-6 h-6" stroke="white" strokeWidth="1.5">
    <path d="M12 12c2.7 0 5-2.3 5-5S14.7 2 12 2 7 4.3 7 7s2.3 5 5 5zm0 2c-3.3 0-10 1.7-10 5v2h20v-2c0-3.3-6.7-5-10-5z" strokeLinecap="round" />
    <path d="M17 10l1.5 1.5L22 8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const DiamondIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" className="w-6 h-6" stroke="white" strokeWidth="1.5">
    <polygon points="12 2 22 9 18 22 6 22 2 9 12 2" strokeLinejoin="round" />
    <line x1="2" y1="9" x2="22" y2="9" />
    <line x1="12" y1="2" x2="6" y2="22" />
    <line x1="12" y1="2" x2="18" y2="22" />
  </svg>
);

// Overlapping avatar pair
const AvatarPair = ({ src1, src2 }) => (
  <div className="flex justify-center mb-4">
    <div className="relative flex">
      <img src={src1} alt="" className="w-16 h-16 rounded-full object-cover border-4 border-[#FF6B35] z-10" />
      <img src={src2} alt="" className="w-16 h-16 rounded-full object-cover border-4 border-[#FF6B35] -ml-5" />
    </div>
  </div>
);

export default function FeaturesSection() {
  return (
    <section className="w-full bg-white py-12 px-4 md:px-8 lg:px-16">
      {/* Header */}
      <div className="text-center mb-10">
        <div className="inline-flex items-center gap-2 border border-gray-200 rounded-full px-4 py-1 text-sm font-medium text-gray-700 mb-5">
          <span className="text-[#FF6B35] font-black text-lg">✦</span>
          Our Feature
        </div>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-[#0D1B2A] leading-tight max-w-3xl mx-auto">
          A perfect place for joyful learning & happy growth
        </h2>
      </div>

      {/* Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-7xl mx-auto">

        {/* Card 1 - Light cream */}
        <div className="bg-[#F8F5EE] rounded-3xl p-6 flex flex-col justify-between min-h-[420px] relative overflow-hidden">
          {/* Watermark */}
          <div className="absolute top-4 right-4 text-[100px] font-black text-gray-200 leading-none select-none pointer-events-none opacity-60" style={{ fontStyle: 'italic' }}>
            le
          </div>

          <div>
            {/* Icon */}
            <div className="w-12 h-12 rounded-full bg-[#FF6B35] flex items-center justify-center mb-6">
              <TeacherIcon />
            </div>

            <h3 className="text-xl font-extrabold text-[#0D1B2A] mb-3">Smart Classroom Activities</h3>
            <p className="text-gray-500 text-sm leading-relaxed mb-6">
              Our play-based learning approach allows children to explore, imagine, and learn through fun, hands-on activities.
            </p>

            {/* Tags */}
            <div className="flex flex-wrap gap-2 mb-6">
              <PillTag label="Learning" />
              <PillTag label="Growth" />
              <PillTag label="Care" />
            </div>
          </div>

          {/* Bottom review bar */}
          <div className="flex items-center justify-between bg-white rounded-2xl px-4 py-3">
            <div className="flex items-center gap-3">
              <div className="flex -space-x-2">
                <img src={AVATAR1} className="w-8 h-8 rounded-full object-cover border-2 border-white" />
                <img src={AVATAR2} className="w-8 h-8 rounded-full object-cover border-2 border-white" />
                <img src={AVATAR3} className="w-8 h-8 rounded-full object-cover border-2 border-white" />
              </div>
              <div>
                <div className="text-[#FF6B35] text-sm">★★★★★</div>
                <p className="text-xs text-gray-500">4.9 / 5 Reviews</p>
              </div>
            </div>
            <button className="w-9 h-9 rounded-full bg-[#FF6B35] flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
              ↗
            </button>
          </div>
        </div>

        {/* Card 2 - Orange */}
        <div className="bg-[#FF6B35] rounded-3xl p-6 flex flex-col items-center text-center min-h-[420px] relative overflow-hidden">
          <AvatarPair src1={headerimg} src2={headerimg} />

          <h3 className="text-xl font-extrabold text-white mb-3">Trained & Caring Teachers</h3>
          <p className="text-orange-100 text-sm leading-relaxed mb-6">
            Our play-based learning approach allows children to explore, imagine, and learn through fun, hands-on activities.
          </p>

          {/* Cartoon children image at bottom */}
          <div className="mt-auto w-full flex justify-center">
            <div className="relative w-full h-44 overflow-hidden rounded-2xl">
              <img
                src={Cartoon}
                alt="Kids"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        {/* Card 3 - Dark Teal */}
        <div className="bg-[#1B4D6E] rounded-3xl p-6 flex flex-col items-center text-center min-h-[420px] relative overflow-hidden">
          {/* Decorative circles */}
          <div className="absolute top-0 right-0 w-48 h-48 rounded-full border border-white/10 -translate-y-1/4 translate-x-1/4 pointer-events-none" />
          <div className="absolute bottom-0 left-0 w-32 h-32 rounded-full border border-white/10 translate-y-1/4 -translate-x-1/4 pointer-events-none" />

          {/* Icon */}
          <div className="w-12 h-12 rounded-full bg-[#FF6B35] flex items-center justify-center mb-5">
            <DiamondIcon />
          </div>

          <h3 className="text-xl font-extrabold text-white mb-3">Learning Hubs</h3>
          <p className="text-blue-200 text-sm leading-relaxed mb-6">
            Our learning approach allows children to explore, imagine, and learn through fun, hands-on activities.
          </p>

          {/* Bottom image */}
          <div className="mt-auto w-full">
            <div className="relative">
              <img
                src={techer}
                alt="Teacher with kids"
                className="w-full h-40 object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}